import { createContext, useContext } from 'react';

import { CockpitPanelIntlKeysEnum } from './cockpit.types';

interface CockpitUiStateContextType {
  openedPanel: CockpitPanelIntlKeysEnum | null;
  isSidebarMaximized: boolean;
  setIsSidebarMaximized: (value: boolean) => void;
}

export const CockpitUiStateContext = createContext<CockpitUiStateContextType | undefined>(undefined);

export const useCockpitUiStateContext = (): CockpitUiStateContextType => {
  const context = useContext(CockpitUiStateContext);
  if (!context) {
    throw new Error('useCockpitUiStateContext must be used within a CockpitUiStateContext.Provider');
  }
  return context;
};
